<template>
  <div class="counting-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>${{ activeFormula }}$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区域 -->
      <div class="simulation-stage dark-stage">
        <svg width="100%" height="380" viewBox="0 0 800 600" preserveAspectRatio="xMidYMid meet">
           <!-- 背景微光网格 -->
           <g stroke="rgba(241, 245, 249, 0.03)" stroke-width="1.5">
              <line v-for="i in 17" :key="'v'+i" :x1="i*50" y1="0" :x2="i*50" y2="600" />
              <line v-for="i in 13" :key="'h'+i" x1="0" :y1="i*50" x2="800" :y2="i*50" />
           </g>

           <!-- 模式: 分类加法原理 (并列结构) -->
           <g v-if="mode === 'addition'" transform="translate(100, 100)">
              <text x="300" y="-30" fill="#f8fafc" font-size="24" text-anchor="middle" font-weight="900">选择一种交通方式 (分类)</text>
              
              <!-- 第一类方案 -->
              <rect x="0" y="20" width="250" height="250" fill="rgba(59, 130, 246, 0.05)" stroke="#3b82f6" stroke-width="2" stroke-dasharray="10,5" rx="15" />
              <text x="125" y="60" fill="#60a5fa" font-size="22" text-anchor="middle" font-weight="900">方案 A (火车 {{ m1 }} 班)</text>
              <g v-for="i in Number(m1)" :key="'tr'+i">
                 <line x1="30" :y1="80 + i*35" x2="220" :y2="80 + i*35" stroke="#3b82f6" stroke-width="6" stroke-linecap="round" />
                 <text x="125" :y="95 + i*35" fill="#fff" font-size="12" text-anchor="middle" font-weight="bold">车次 {{i}}</text>
              </g>

              <text x="300" y="145" fill="#f8fafc" font-size="48" text-anchor="middle" font-weight="950">+</text>

              <!-- 第二类方案 -->
              <rect x="350" y="20" width="250" height="250" fill="rgba(239, 68, 68, 0.05)" stroke="#ef4444" stroke-width="2" stroke-dasharray="10,5" rx="15" />
              <text x="475" y="60" fill="#f87171" font-size="22" text-anchor="middle" font-weight="900">方案 B (飞机 {{ m2 }} 班)</text>
              <g v-for="i in Number(m2)" :key="'ap'+i">
                 <line x1="380" :y1="80 + i*35" x2="570" :y2="80 + i*35" stroke="#ef4444" stroke-width="6" stroke-linecap="round" />
                 <text x="475" :y="95 + i*35" fill="#fff" font-size="12" text-anchor="middle" font-weight="bold">航班 {{i}}</text>
              </g>
              
              <text x="300" y="340" fill="#10b981" font-size="32" text-anchor="middle" font-weight="950" style="text-shadow: 0 0 10px rgba(16,185,129,0.3)">总走法: {{ Number(m1) + Number(m2) }} 种</text>
           </g>

           <!-- 模式: 分步乘法原理 (串联结构) -->
           <g v-if="mode === 'multiplication'" transform="translate(100, 100)">
              <text x="300" y="-30" fill="#f8fafc" font-size="24" text-anchor="middle" font-weight="900">分步完成旅程 (A → B → C)</text>
              
              <!-- 三个地点节点 -->
              <circle cx="20" cy="150" r="18" fill="#3b82f6" />
              <text x="20" y="195" fill="#60a5fa" font-size="22" text-anchor="middle" font-weight="900">地点 A</text>

              <circle cx="300" cy="150" r="18" fill="#fbbf24" />
              <text x="300" y="195" fill="#fbbf24" font-size="22" text-anchor="middle" font-weight="900">中间站 B</text>

              <circle cx="580" cy="150" r="18" fill="#ef4444" />
              <text x="580" y="195" fill="#f87171" font-size="22" text-anchor="middle" font-weight="900">终点 C</text>
              
              <!-- 第一步路径 -->
              <g v-for="i in Number(m1)" :key="'s1_'+i">
                 <path :d="`M 35 150 Q 160 ${50 + i*50} 285 150`" fill="none" stroke="rgba(59, 130, 246, 0.4)" stroke-width="3" />
                 <circle :cx="160" :cy="50 + i*50 + (i-1)*5" r="5" fill="#3b82f6" />
              </g>
              <text x="160" y="235" fill="#60a5fa" font-size="20" text-anchor="middle" font-weight="bold">第1步: {{ m1 }} 种可能</text>
              <text x="300" y="270" fill="#f8fafc" font-size="36" text-anchor="middle" font-weight="950">×</text>

              <!-- 第二步路径 -->
              <g v-for="j in Number(m2)" :key="'s2_'+j">
                 <path :d="`M 315 150 Q 440 ${50 + j*50} 565 150`" fill="none" stroke="rgba(239, 68, 68, 0.4)" stroke-width="3" />
                 <circle :cx="440" :cy="50 + j*50 + (j-1)*5" r="5" fill="#ef4444" />
              </g>
              <text x="440" y="235" fill="#f87171" font-size="20" text-anchor="middle" font-weight="bold">第2步: {{ m2 }} 种可能</text>
              
              <text x="300" y="340" fill="#10b981" font-size="32" text-anchor="middle" font-weight="950" style="text-shadow: 0 0 10px rgba(16,185,129,0.3)">总路径: {{ Number(m1) * Number(m2) }} 种</text>
           </g>

           <text x="50" y="550" fill="rgba(255,255,255,0.3)" font-size="16" font-weight="bold">组合计数原理交互演进视图</text>
        </svg>

        <div class="hud-panel">
           <div class="hud-item blue">
              <label>逻辑类型</label>
              <span class="val">{{ mode === 'addition' ? '分类并行' : '分步串行' }}</span>
           </div>
           <div class="hud-item cyan">
              <label>最终计数</label>
              <span class="val">N = {{ resultCount }}</span>
           </div>
        </div>
      </div>

      <!-- 控制面板 -->
      <div class="compact-controls">
        <div class="control-card">
           <div class="control-grid-mini">
              <div class="s-item">
                 <label>核心原理切换</label>
                 <el-radio-group v-model="mode" size="mini">
                   <el-radio-button label="addition">分类加法</el-radio-button>
                   <el-radio-button label="multiplication">分步乘法</el-radio-button>
                 </el-radio-group>
              </div>
              <div class="s-item">
                 <label>方案1/第一步 ({{ m1 }})</label>
                 <el-slider v-model="m1" :min="1" :max="5" size="small"></el-slider>
              </div>
              <div class="s-item">
                 <label>方案2/第二步 ({{ m2 }})</label>
                 <el-slider v-model="m2" :min="1" :max="5" size="small"></el-slider>
              </div>
           </div>
        </div>

        <div class="discovery-card-compact" v-latex>
           <i class="el-icon-info"></i>
           <div class="discovery-content">
              <p><strong>数学释义：</strong>{{ modeDesc }}。{{ tipText }}</p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountingPrincipleViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mode: 'multiplication',
      m1: 3,
      m2: 2
    }
  },
  mounted() {
    this.detectMode();
  },
  watch: {
    knowledgePoint: {
       handler() { this.detectMode(); },
       immediate: true
    }
  },
  computed: {
    topicIntro() {
       return this.mode === 'addition' ? '分类加法：完成一件事有几类互相排斥的方案' : '分步乘法：任务需分阶段连续执行才能完成';
    },
    activeFormula() {
       return this.mode === 'addition' ? 'N = m₁ + m₂ + ...' : 'N = m₁ × m₂ × ...';
    },
    resultCount() {
       return this.mode === 'addition' ? (Number(this.m1) + Number(this.m2)) : (Number(this.m1) * Number(this.m2));
    },
    modeDesc() {
       if (this.mode === 'addition') return '各类方案中，任意选择一种方法即可达成目标。它是“并”的逻辑，不存在跨类依赖';
       return '每一步都是达成最终目标不可或缺的一环，且各步骤独立选择。它是“交”的逻辑，体现了方案的组合爆发';
    },
    tipText() {
       return '调节参数，观察不同模式下“走法”总数的增长模型差异。';
    }
  },
  methods: {
    detectMode() {
       const kp = this.knowledgePoint || '';
       if (/加法|分类/.test(kp)) this.mode = 'addition';
       else this.mode = 'multiplication';
    }
  }
}
</script>

<style scoped lang="scss">
.counting-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.viz-header-compact { display: flex; justify-content: space-between; align-items: center; padding: 0 4px; .brief { font-size: 14px; color: #1e293b; font-weight: 700; } .formula-chip { background: #f0f9ff; color: #0369a1; border: 1px solid #bae6fd; padding: 5px 16px; border-radius: 20px; font-weight: 900; font-family: "Courier New", monospace; font-size: 14px; } }
.simulation-stage { flex: 1; min-height: 380px; background: #020617; border-radius: 12px; border: 1.5px solid #1e293b; position: relative; overflow: hidden; .hud-panel { position: absolute; top: 15px; right: 15px; display: flex; flex-direction: column; gap: 10px; .hud-item { background: rgba(15, 23, 42, 0.85); border-radius: 10px; border: 1px solid #334155; padding: 6px 14px; label { display: block; font-size: 11px; color: #94a3b8; font-weight: 900; margin-bottom: 2px; } .val { font-size: 14px; color: #f8fafc; font-weight: 900; } &.blue { border-left: 4px solid #3b82f6; } &.cyan { border-left: 4px solid #10b981; } } } }
.compact-controls { flex: 0; display: flex; flex-direction: column; gap: 8px; }
.control-card { background: #ffffff; padding: 14px 18px; border-radius: 12px; border: 1px solid #e2e8f0; }
.control-grid-mini { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; .s-item { label { font-size: 12px; color: #475569; font-weight: 900; margin-bottom: 4px; display: block; } } }
.discovery-card-compact { background: #f8fafc; padding: 12px 16px; border-radius: 12px; border: 1px solid #e2e8f0; display: flex; align-items: flex-start; gap: 12px; i { color: #3b82f6; font-size: 1.2rem; } .discovery-content { flex: 1; p { margin: 0; font-size: 13px; color: #334155; line-height: 1.6; strong { color: #0f172a; font-weight: 900; } } } }
</style>
